'use strict';

import React from 'react';
import ReactDOM from 'react-dom';
import Modal from "react-bootstrap/Modal";
import {CreditRow} from "./credit-row";

export {Credit};

class Credit extends React.Component {
    constructor(props) {
        super(props);

        this.state = {modalIsOpen: true, openedTab: 'monobank'};

        this.openModal = this.openModal.bind(this);
        this.setIsOpen = this.setIsOpen.bind(this);
        this.closeModal = this.closeModal.bind(this);

        this.onUpdate = this.onUpdate.bind(this);

    }

    setIsOpen(value){
        this.setState({modalIsOpen: value});
    }

    openModal() {
        this.setIsOpen(true);
    }
    closeModal() {
        this.setIsOpen(false);
    }

    onUpdate(json) {
        this.setState({cart: json.data});
    }


    updateState(result){
        this.setState({cart: result.data});
        //this.setState({compatible: result.data.compatible});
    }

    render() {
        let paylater_rates = [];
        let paylater_ranges = [];
        this.props.offers[16].forEach(elem => {
            paylater_rates.push(parseFloat(elem.coef));
            paylater_ranges.push(parseFloat(elem.month) + 1);
        });


        return (
            <Modal show={this.state.modalIsOpen} onHide={this.closeModal} className={"modal-w-600 fade modal-select-bank"} dialogClassName={"modal-dialog-centered"}>
                <Modal.Header closeButton>
                    <h5 className="modal-title">{lajax.t('Выберите кредитное предложение')}</h5>
                </Modal.Header>
                <Modal.Body>
                    <ul className="nav nav-tabs credit-item__mobile-nav" role="tablist">
                        <If condition={this.props.cart.mb_max_payment_quantity}>
                        <li className="nav-item" role="presentation">
                            <button className={"nav-link" + (this.state.openedTab == 'monobank' ? ' active' : '')}
                                onClick={(e) => this.setState({openedTab: 'monobank'})}
                                type="button" role="tab" aria-selected="true">{lajax.t('Монобанк')}
                            </button>
                        </li>
                        </If>
                        <If condition={this.props.cart.pl_max_payment_quantity}>
                        <li className="nav-item" role="presentation">
                            <button className={"nav-link" + (this.state.openedTab == 'paylater' ? ' active' : '')}
                                    onClick={(e) => this.setState({openedTab: 'paylater'})}
                                    type="button" role="tab" aria-selected="true">{lajax.t('Плати позже')}
                            </button>
                        </li>
                        </If>
                        <li className="nav-item" role="presentation">
                            <button className={"nav-link" + (this.state.openedTab == 'privat' ? ' active' : '')}
                                    onClick={(e) => this.setState({openedTab: 'privat'})}
                                    type="button" role="tab" aria-selected="true">{lajax.t('Приватбанк')}
                            </button>
                        </li>
                        <If condition={this.props.cart.pu_max_payment_quantity}>
                            <li className="nav-item" role="presentation">
                                <button className={"nav-link" + (this.state.openedTab == 'pumb' ? ' active' : '')}
                                        onClick={(e) => this.setState({openedTab: 'pumb'})}
                                        type="button" role="tab" aria-selected="true">{lajax.t('ПУМБ')}
                                </button>
                            </li>
                        </If>
                        <If condition={this.props.cart.ab_max_payment_quantity}>
                            <li className="nav-item" role="presentation">
                                <button className={"nav-link" + (this.state.openedTab == 'abank' ? ' active' : '')}
                                        onClick={(e) => this.setState({openedTab: 'abank'})}
                                        type="button" role="tab" aria-selected="true">{lajax.t('Абанк')}
                                </button>
                            </li>
                        </If>
                    </ul>
                    <div className="tab-content" id="accordionBank">
                        <If condition={this.props.cart.mb_max_payment_quantity}>
                        <CreditRow
                            title={lajax.t('Оплата частями MonoBank')}
                            rewrite={"monobank"}
                            openedTab={this.state.openedTab == "monobank"}
                            ranges={new Array(this.props.cart.mb_max_payment_quantity - 3 + 1).fill().map((d, i) => i + 3)}
                            cart={this.props.cart}
                        />
                        </If>
                        <If condition={this.props.cart.pl_max_payment_quantity}>
                        <CreditRow
                            title={lajax.t('Плати Пізніше ПАО "Плати Пізніше"')}
                            rewrite={"paylater"}
                            openedTab={this.state.openedTab == "paylater"}
                            short={lajax.t("Плати позже")}
                            rates={paylater_rates}
                            ranges={new Array(this.props.cart.pl_max_payment_quantity - 3 + 1).fill().map((d, i) => i + 3)}
                            cart={this.props.cart}

                        />
                        </If>
                        <If condition={this.props.cart.pb_max_payment_quantity}>
                        <CreditRow
                            title={lajax.t('Оплата частинами «ПриватБанк»')}
                            rewrite={"privat"}
                            openedTab={this.state.openedTab == "privat"}
                            ranges={new Array(this.props.cart.pb_max_payment_quantity - 3 + 1).fill().map((d, i) => i + 3)}
                            cart={this.props.cart}
                        />
                        </If>

                        <If condition={this.props.cart.pu_max_payment_quantity}>
                            <CreditRow
                                title={lajax.t('Оплата частинами «ПУМБ»')}
                                rewrite={"pumb"}
                                openedTab={this.state.openedTab == "pumb"}
                                ranges={new Array(this.props.cart.pu_max_payment_quantity - 3 + 1).fill().map((d, i) => i + 3)}
                                cart={this.props.cart}
                            />
                        </If>
                        <If condition={this.props.cart.ab_max_payment_quantity}>
                            <CreditRow
                                title={lajax.t('Оплата частинами «А-банк»')}
                                rewrite={"abank"}
                                openedTab={this.state.openedTab == "abank"}
                                ranges={new Array(this.props.cart.ab_max_payment_quantity - 3 + 1).fill().map((d, i) => i + 3)}
                                cart={this.props.cart}
                            />
                        </If>


                    </div>
                </Modal.Body>
                {/*
                        <Modal.Footer>
                        </Modal.Footer>
                        */}
            </Modal>
        );
    }
}

const e = React.createElement;

export function creditShow(cartData)
{
    try{
        ReactDOM.unmountComponentAtNode(document.querySelector('#credit_app'));
    }catch(e){

    }

    const domContainer = document.querySelector('#credit_app');

    if(domContainer){
        ReactDOM.render(e(Credit, {
            cart: cartData,
            offers: window.offers
        }), domContainer);
    }
}


